import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { Authentication } from "@swegon/sds-core";

const AuthorizationRoute = ({ children }) => {
    const { isAuthenticated, checkProdAuthority } = useContext(Authentication.AuthContext);
    const location = useLocation();

    if (isAuthenticated()) {
        return children;
    }

    const after_redirect = window.location.href.substring(
        window.location.origin.length
    );
    // A path like "//evil.com" would become an off-site redirect after login
    if (Authentication.isSafeRedirect(after_redirect)) {
        localStorage.setItem("after_redirect", after_redirect);
    }

    checkProdAuthority(location);

    return <Navigate to="/login" state={{ from: location }} replace />;
};

export default AuthorizationRoute;
